import React from 'react';

import {ClickToEditButton} from 'app/components/general/ClickToEditButton';
import {ListMessage} from 'app/components/general/ListMessage';
import {UserContentContainer} from 'app/general/structures/UserContentContainer';
import {ImagesCarousel} from 'app/general/widgets/ImagesCarousel';
import {policyHasAnyContent} from 'app/policies/components/PolicyEditPage/utils';
import {ProcedureStepFiles} from 'app/procedures/components/ProcedureStepFiles';
import {gt} from 'app/utils/i18n';

import type {PolicyContentType} from 'app/policies/types';
type Props = {
  content: Omit<PolicyContentType, 'name' | 'url' | 'html_url'>;
  editable: boolean;
  mediaURL: string;
  mediaURLRead: string;
};

export const ViewPolicyContent = ({
  content,
  editable,
  mediaURL,
  mediaURLRead,
}: Props) =>
  policyHasAnyContent(content) ? (
    <div>
      <UserContentContainer
        mediaURL={mediaURL}
        mediaURLRead={mediaURLRead}
        content={content.content}
      />
      {content.videos.length > 0 || content.embeds.length > 0 ? (
        <div className="images">
          <ImagesCarousel
            onClick={(e) => e.stopPropagation()}
            images={[...content.videos, ...content.embeds]}
          />
        </div>
      ) : null}
      {content.files.length > 0 ? (
        <ProcedureStepFiles files={content.files} />
      ) : null}
    </div>
  ) : (
    <ListMessage>
      {editable ? (
        <ClickToEditButton>
          {gt('Click here to edit policy content.')}
        </ClickToEditButton>
      ) : (
        gt('This policy has no content.')
      )}
    </ListMessage>
  );
